// Copyright 2018 Sorama B.V.

import {
    BeamformingProjectionSet,
    BeamformingProjectionSetAnalysisProperties,
    GenericMeasurement,
} from "datatypes/SoramaWebApi";

export abstract class IBeamformingProcessingService {
    /**
     * Get beamforming projections for the given measurement.
     * @param measurement Measurement to get the measurement data for the beamforming projections from.
     * @param frameProperties Properties for each of the frames to be retrieved.
     * @param computationProgressCallback Optional progress callback which will receive periodic progress updates.
     */
    abstract getBeamformingProjections(
        measurement: GenericMeasurement,
        frameProperties: BeamformingProjectionSetAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<BeamformingProjectionSet>;
}
